import { AutogenModelLeaveTransaction, AutogenRowLeaveTransaction } from "./autogen/AutogenModelLeaveTransaction";

export class ModelLeaveTransaction extends AutogenModelLeaveTransaction<RowLeaveTransaction> {
	constructor() {
		super(RowLeaveTransaction);
	}
}

export class RowLeaveTransaction extends AutogenRowLeaveTransaction {
}